// extracted by css-extract-rspack-plugin
export default {"cls1":"Carousel-cls1_0a_","cls2":"Carousel-cls2_zB5 Carousel-cls1_0a_"};